const TOP_LEVEL_PATHS = {
    ADMIN: '~admin',
    SETTINGS: 'settings',
    TERMS: 'terms'
};

export default TOP_LEVEL_PATHS;
